
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funding-history/billing-details/payment-methods",
      function () {
        return require("private-next-pages/funding-history/billing-details/payment-methods/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funding-history/billing-details/payment-methods"])
      });
    }
  